<template>
  <div>
    <div v-if="accountUpdated">
      <h2 v-html="loc('components.editAccount.accountUpdated')"></h2>
    </div>
    <div v-else>
      <v-form :fields="fields" :form-data="formData" :form-errors="formErrors">
        <div slot="buttons" class="v-form-button-div">
          <button :disabled="sendDisabled" v-on:click="update" type="submit" class="btn btn--white">{{loc('updateInformation')}}</button>
        </div>
      </v-form>
    </div>
  </div>
</template>

<script>

import VForm from './v-form.vue';

export default {
  components: {
    'v-form': VForm
  },
  name: 'ViewEditAccount',
  data: function () {
    return {
      formErrors: {},
      formData: {},
      accountUpdated: false,
      sendDisabled: false
    }
  },
  computed: {
    fields() {
      if(this.$store.getters.countrySelectOptions) {
        return [{
          name: 'id',
          value: this.$store.state.user.info.id,
          label: this.loc('firstName'),
          type: 'hidden'
        }, {
          name: 'role',
          value: this.$store.state.user.role,
          label: this.loc('role'),
          type: 'hidden'
        }, {
          name: 'firstName',
          value: this.$store.state.user.info.firstName,
          label: this.loc('firstName'),
          type: 'text'
        }, {
          name: 'lastName',
          value: this.$store.state.user.info.lastName,
          label: this.loc('lastName'),
          type: 'text',
        }, {
          name: 'phone',
          value: this.$store.state.user.info.phone,
          label: this.loc('phone'),
          type: 'text'
        }, {
          name: 'country',
          value: this.$store.state.user.info.country && this.$store.state.user.info.country.countryCode || '', // User current user country as a default
          label: this.loc('country'),
          options: this.$store.getters.countrySelectOptions,
          type: 'select'
        }];
      }

      return [];
    },
  },
  methods: {
    async update() {
      this.sendDisabled = true;

      return this.$api.updateUser(this.formData.id, this.formData).then(res => {
        this.sendDisabled = false;

        // Errors in form
        if(res.code === 400) {
          this.formErrors = res.result.fields;
        }

        if(res.code === 200) {
          this.$store.commit('setCurrentUser', res.result.user);
          this.accountUpdated = true;
        }
      });

    }
  },
  mounted () {
    this.$store.dispatch('getCountries');
  }
}
</script>
